"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importStar(require("react"));
var image_1 = require("@chakra-ui/image");
var layout_1 = require("@chakra-ui/layout");
var button_1 = require("@chakra-ui/button");
var icons_1 = require("@chakra-ui/icons");
var react_2 = require("@chakra-ui/react");
var react_3 = require("@emotion/react");
var HeadWrapper = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("header", null,
        react_1.default.createElement(layout_1.Box, { h: { base: "5rem", md: "6.2rem" }, w: "100%", boxShadow: "sm", mb: "1px" },
            react_1.default.createElement(layout_1.Flex, { w: "100%", h: "100%", maxW: { md: "100%", xl: "1240px" }, mx: "auto", bg: "white", align: "center", padding: { base: 3 }, justifyContent: "space-between" }, children))));
};
var HeaderLogo = function (_a) {
    var headerUrl = _a.headerUrl, shopCode = _a.shopCode;
    if (headerUrl)
        return (react_1.default.createElement(layout_1.Box, { as: "a", href: shopCode ? "/" + shopCode : "/main", maxW: { base: "10rem", md: "18rem" }, maxH: { md: "5rem" } },
            react_1.default.createElement(image_1.Img, { src: headerUrl, alt: "logo", maxH: { md: "5rem" } })));
    return react_1.default.createElement(layout_1.Box, { minW: { base: "10rem", md: "18rem" } });
};
var NavList = function (headerUrl, isInquire, onModalOpen, headerMenus, shopCode) {
    var _a = (0, react_2.useDisclosure)(), isOpen = _a.isOpen, onOpen = _a.onOpen, onClose = _a.onClose;
    var isSize = (0, react_2.useBreakpointValue)({
        base: "sp",
        md: "pc",
    });
    (0, react_1.useEffect)(function () {
        if (isSize === "pc")
            onClose();
        if (isOpen) {
            document.body.style.position = "fixed";
        }
        else {
            document.body.style.removeProperty("position");
        }
    }, [isOpen, isSize]);
    return (0, react_2.useBreakpointValue)({
        base: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(HeadWrapper, null,
                react_1.default.createElement(HeaderLogo, { headerUrl: headerUrl, shopCode: shopCode }),
                react_1.default.createElement(react_2.List, { display: "flex", alignItems: { md: "center" }, fontSize: "1.5rem" },
                    isInquire && (react_1.default.createElement(react_2.ListItem, { marginRight: "1.2rem" },
                        react_1.default.createElement(button_1.IconButton, { display: { md: "none" }, color: "white", bg: "#F9B812", _hover: {
                                color: "white",
                                backgroundColor: "#D59D0F",
                            }, _active: {
                                color: "white",
                                backgroundColor: "#BF8D0D",
                            }, "aria-label": "\u304A\u554F\u3044\u5408\u308F\u305B", icon: react_1.default.createElement(icons_1.EmailIcon, null), isRound: true, zIndex: 3, lineHeight: "1", height: "3rem", minWidth: "3rem", fontSize: "1.4rem", onClick: onModalOpen }))),
                    headerMenus && (react_1.default.createElement(react_2.ListItem, null,
                        react_1.default.createElement(button_1.IconButton, { display: { md: "none" }, color: "white", bg: "#F9B812", _hover: {
                                color: "white",
                                backgroundColor: "#D59D0F",
                            }, _active: {
                                color: "white",
                                backgroundColor: "#BF8D0D",
                            }, "aria-label": "\u30E1\u30CB\u30E5\u30FC", icon: react_1.default.createElement(icons_1.HamburgerIcon, null), zIndex: 3, lineHeight: "1", height: "3rem", minWidth: "3rem", fontSize: "1.4rem", onClick: onOpen }))))),
            isOpen && (react_1.default.createElement(layout_1.Box, { position: "fixed", top: "0", left: "0", width: "100%", height: "100%", zIndex: 4, css: menuBackbround, onClick: onClose },
                react_1.default.createElement(layout_1.Box, { background: "white", onClick: function (event) {
                        event.stopPropagation();
                    } },
                    react_1.default.createElement(layout_1.Box, { zIndex: 5, h: { base: "5rem", md: "6.2rem" }, w: "100%", boxShadow: "sm" },
                        react_1.default.createElement(layout_1.Flex, { w: "100%", h: "100%", maxW: {
                                md: "100%",
                                xl: "1240px",
                            }, mx: "auto", bg: "white", color: "blue.400", align: "center", padding: { base: 3 } },
                            react_1.default.createElement(HeaderLogo, { headerUrl: headerUrl, shopCode: shopCode }),
                            react_1.default.createElement(react_2.List, { width: "100%", justifyContent: "end", display: "flex", alignItems: {
                                    md: "center",
                                }, fontSize: "1.5rem" },
                                react_1.default.createElement(react_2.ListItem, null,
                                    react_1.default.createElement(button_1.IconButton, { display: {
                                            md: "none",
                                        }, color: "white", bg: "#F9B812", _hover: {
                                            color: "white",
                                            backgroundColor: "#D59D0F",
                                        }, _active: {
                                            color: "white",
                                            backgroundColor: "#BF8D0D",
                                        }, "aria-label": "\u30E1\u30CB\u30E5\u30FC", icon: react_1.default.createElement(icons_1.CloseIcon, null), zIndex: 3, lineHeight: "1", height: "3rem", minWidth: "3rem", fontSize: "1.4rem", onClick: onClose }))))),
                    react_1.default.createElement(react_2.List, { padding: "3rem", width: "100%", alignItems: { md: "center" }, fontSize: "1.5rem", maxHeight: "80vh", overflow: "scroll" }, headerMenus &&
                        headerMenus.map(function (nemuData) { return (react_1.default.createElement(react_2.ListItem, { key: nemuData.name },
                            react_1.default.createElement(react_2.Link, { href: nemuData.front_path }, nemuData.name))); }))))))),
        md: (react_1.default.createElement(HeadWrapper, null,
            react_1.default.createElement(HeaderLogo, { headerUrl: headerUrl, shopCode: shopCode }),
            react_1.default.createElement(react_2.List, { justifyContent: "end", display: { md: "inline-flex" }, alignItems: { md: "center" }, fontSize: "1.5rem" },
                headerMenus &&
                    headerMenus.map(function (nemuData) { return (react_1.default.createElement(react_2.ListItem, { key: nemuData.name, paddingRight: { md: "1.2rem" }, paddingLeft: { md: "1.2rem" } },
                        react_1.default.createElement(react_2.Link, { href: nemuData.front_path }, nemuData.name))); }),
                isInquire && (react_1.default.createElement(react_2.ListItem, null,
                    react_1.default.createElement(button_1.Button, { display: {
                            base: "none",
                            md: "inline-flex",
                        }, height: "100%", padding: "1rem 3rem", fontSize: "1.6rem", color: "white", bg: "#F9B812", lineHeight: "1", _hover: {
                            color: "white",
                            backgroundColor: "#D59D0F",
                        }, _active: {
                            color: "white",
                            backgroundColor: "#BF8D0D",
                        }, borderRadius: "full", onClick: onModalOpen }, "\u304A\u554F\u3044\u5408\u308F\u305B"),
                    react_1.default.createElement(button_1.IconButton, { display: { md: "none" }, color: "white", bg: "#F9B812", _hover: {
                            color: "white",
                            backgroundColor: "#D59D0F",
                        }, _active: {
                            color: "white",
                            backgroundColor: "#BF8D0D",
                        }, "aria-label": "\u304A\u554F\u3044\u5408\u308F\u305B", icon: react_1.default.createElement(icons_1.EmailIcon, null), isRound: true, zIndex: 3, lineHeight: "1", height: "3rem", minWidth: "3rem", fontSize: "1.4rem", onClick: onModalOpen })))))),
    });
};
var Header = function (_a) {
    var headerUrl = _a.headerUrl, _b = _a.isInquire, isInquire = _b === void 0 ? false : _b, _c = _a.onOpen, onOpen = _c === void 0 ? function () { } : _c, _d = _a.headerMenus, headerMenus = _d === void 0 ? null : _d, shopCode = _a.shopCode;
    return react_1.default.createElement(react_1.default.Fragment, null,
        " ",
        NavList(headerUrl, isInquire, onOpen, headerMenus, shopCode));
};
exports.Header = Header;
var menuBackbround = (0, react_3.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    backdrop-filter: blur(3px);\n    background-color: rgba(0, 0, 0, 0.2);\n"], ["\n    backdrop-filter: blur(3px);\n    background-color: rgba(0, 0, 0, 0.2);\n"])));
var templateObject_1;
